export enum DoplanerModules {
    Tickets = 'ticket',
    TicketSetup = 'setup',
    Employee = 'employee',
    Finance = 'finance',
    TimeTracking = 'time-tracking',
  }